const adjectives = [
  'Swift', 'Brave', 'Calm', 'Bright', 'Quick', 'Silent', 'Bold', 'Warm',
  'Clever', 'Gentle', 'Nimble', 'Keen', 'Wise', 'Vivid', 'Noble', 'Steady',
  'Agile', 'Serene', 'Mystic', 'Cosmic', 'Golden', 'Silver', 'Crystal', 'Azure'
]

const nouns = [
  'Penguin', 'Cloud', 'River', 'Tiger', 'Falcon', 'Oak', 'Star', 'Wave',
  'Phoenix', 'Panda', 'Wolf', 'Eagle', 'Lotus', 'Raven', 'Fox', 'Bear',
  'Otter', 'Hawk', 'Orchid', 'Cedar', 'Coral', 'Maple', 'Ember', 'Frost'
]

export function generateRandomName(): string {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)]
  const noun = nouns[Math.floor(Math.random() * nouns.length)]
  return `${adj} ${noun}`
}
